import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-research-entrepreneurship-cell',
    templateUrl: './research-entrepreneurship-cell.component.html',
    styleUrls: ['./research-entrepreneurship-cell.component.scss']
})
export class ResearchEntrepreneurshipCellComponent implements OnInit {
    src: string = '/assets/pdf/Entreprenurship Cell.pdf';
    title: string = 'Entrepreneurship Cell';

    constructor() { }

    ngOnInit(): void {
    }

}
